import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { CardComp, ButtonComp } from "../../../components";

const MODULE_TITLES = {
  "other-services": "Other Services",
  "socio-services": "Socio-Services",
  "gallery-sharing": "Gallery Sharing",
  "society-election": "Society Election",
  "commodities-management": "Commodities Management",
  "dividend-management": "Dividend Management",
  "financial-accounting": "Financial Accounting",
};

const PageWrap = styled.div`
  min-height: calc(100vh - 120px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: linear-gradient(
    165deg,
    rgba(49, 119, 140, 0.06) 0%,
    rgba(139, 49, 58, 0.04) 50%,
    #ffffff 100%
  );
`;

const AccentBar = styled.div`
  height: 4px;
  width: 72px;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secondary) 100%);
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-family: "DM Sans", "Work Sans", system-ui, sans-serif;
  font-size: 26px;
  font-weight: 600;
  color: #383838;
  margin: 0 0 12px;
  line-height: 1.25;
`;

const Lead = styled.p`
  font-size: 16px;
  color: #525252;
  line-height: 1.6;
  margin: 0 0 8px;
  max-width: 440px;
`;

const Sub = styled.p`
  font-size: 14px;
  color: var(--color-secondary);
  font-weight: 500;
  margin: 0 0 28px;
`;

const IconWrap = styled.div`
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: rgba(49, 119, 140, 0.12);
  color: var(--color-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

function BuildIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
    </svg>
  );
}

export default function ModuleInDevelopment() {
  const { moduleKey } = useParams();
  const navigate = useNavigate();
  const title = moduleKey ? MODULE_TITLES[moduleKey] : null;

  useEffect(() => {
    if (moduleKey && !MODULE_TITLES[moduleKey]) {
      navigate("/super_admin/dashboard", { replace: true });
    }
  }, [moduleKey, navigate]);

  if (!title) {
    return null;
  }

  return (
    <PageWrap className="mx-2 mx-lg-4">
      <CardComp cardClassName="border-0 shadow-sm w-100" cardBodyClassName="p-0">
        <div
          className="px-3 py-4 py-md-5 text-center d-flex flex-column align-items-center mx-auto"
          style={{ maxWidth: 560 }}
        >
          <IconWrap>
            <BuildIcon />
          </IconWrap>
          <AccentBar />
          <Title>{title}</Title>
          <Lead>
            We are actively building this module. You will see full functionality here in a
            future release.
          </Lead>
          <Sub>We will announce when it is ready for use.</Sub>
          <ButtonComp
            btnText="Back to dashboard"
            btnClassName="text-white px-4 py-2 rounded"
            ButtonInlineStyle={{
              backgroundColor: "var(--color-primary)",
              border: "none",
              minWidth: 200,
            }}
            onClick={() => navigate("/super_admin/dashboard")}
          />
        </div>
      </CardComp>
    </PageWrap>
  );
}
